import { Injectable, inject } from '@angular/core';
import { UtilStore } from '../stores/util.store';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private utilStore = inject(UtilStore);

  readonly isLoading = this.utilStore.isLoading;
  readonly loadingFailed = this.utilStore.loadingFailed;

  setLoadingStarted(): void {
    this.utilStore.setLoadingStarted();
  }

  setLoadingFinished(error = false): void {
    this.utilStore.setLoadingFinished(error);
  }

  resetState(): void {
    this.utilStore.resetState();
  }
}
